// utils/cartHelpers.js

export const calculateTotalWithCharges = (
  cartItems = [],
  selectedItem = null,
  additionalCharges = []
) => {
  let totalItemPrice = 0;

  const allItems = [...cartItems];

  if (selectedItem) {
    allItems.push(selectedItem);
  }

  totalItemPrice = allItems.reduce((acc, item) => {
    return acc + (parseFloat(item.totalPrice) || 0);
  }, 0);

  let totalCharges = 0;

  additionalCharges.forEach((charge) => {
    if (charge?.isActive) {
      if (charge.type === "fixed") {
        totalCharges += parseFloat(charge.fee);
      } else if (charge.type === "percentage") {
        totalCharges += (totalItemPrice * parseFloat(charge.fee)) / 100;
      }
    }
  });

  const finalTotal = totalItemPrice + totalCharges;

  return {
    totalItemPrice,
    totalCharges,
    finalTotal,
  };
};
